var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInstantOutfit(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.875 14.5V3.5H14.125V14.5H12.875Z",
    fill: "#47423D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.875 6.5H8.125V14.5H6.875V6.5Z",
    fill: "#47423D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.875 14.5V10.5H5.125V14.5H3.875Z",
    fill: "#47423D"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.875 8.5V14.5H11.125V8.5H9.875Z",
    fill: "#47423D"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1 2.5C1 1.67157 1.67157 1 2.5 1H15.5C16.3284 1 17 1.67157 17 2.5V15.5C17 16.3284 16.3284 17 15.5 17H2.5C1.67157 17 1 16.3284 1 15.5V2.5ZM2.5 2.25H15.5C15.6381 2.25 15.75 2.36193 15.75 2.5V15.5C15.75 15.6381 15.6381 15.75 15.5 15.75H2.5C2.36193 15.75 2.25 15.6381 2.25 15.5V2.5C2.25 2.36193 2.36193 2.25 2.5 2.25Z",
    fill: "#47423D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstantOutfit);
export default __webpack_public_path__ + "static/media/instant-outfit.d365054a46da84504c11153ca4096da2.svg";
export { ForwardRef as ReactComponent };